import { Button, Page } from '@rammetec/design-system'
import { useNavigate } from 'react-router-dom'

export function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <Page
      name="syscolect.not-found"
      title="Página não encontrada"
      description="A rota requisitada não existe."
      actions={<Button onClick={() => navigate('/')}>Ir para o início</Button>}
    />
  )
}
